import { memo } from "react";
import PropTypes from "prop-types";
import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const FGHoverCard = ({ title, timeline, children }) => {
  const theme = useTheme();

  return (
    <Tooltip
      arrow
      placement="bottom-start"
      enterDelay={150}
      title={
        <Box
          sx={{
            minWidth: 300,
            p: 1,
          }}
        >
          <Typography variant="body1" fontWeight={700} mb={1}>
            {title}
          </Typography>
          {timeline.map((item, index) => (
            <Box
              key={`${item.label}-${index}`}
              display="flex"
              alignItems="flex-start"
              mb={1}
            >
              <FiberManualRecordIcon
                sx={{
                  fontSize: 10,
                  color:
                    item.color ||
                    (item.label.toLowerCase().includes("expected dispatch")
                      ? theme.palette.orange.dark
                      : theme.palette.primary.main),
                  mt: 0.5,
                  mr: 1,
                }}
              />
              <Box>
                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.grey[700], fontWeight: 600 }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  {item.value}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      }
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: theme.palette.common.white,
            color: theme.palette.text.primary,
            borderRadius: 2,
            boxShadow: 3,
            p: 1,
          },
        },
        arrow: {
          sx: {
            color: theme.palette.common.white,
          },
        },
      }}
    >
      <Box component="span">{children}</Box>
    </Tooltip>
  );
};

FGHoverCard.propTypes = {
  title: PropTypes.string.isRequired,
  timeline: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      color: PropTypes.string,
    }),
  ).isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(FGHoverCard);
